import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {resetGame} from "../FlipMatch/thunks";
import FlipMatchState from "../FlipMatchState/FlipMatchState";
import {FLIP_MATCH_STATE_TYPE} from "../FlipMatch/constants";

class FlipMatchReset extends React.Component {

    handleResetClick = () => {
        const { confirm, resetGameAction } = this.props;
        if (confirm && window.confirm(confirm)) {
            resetGameAction();
        }
    };

    render() {
        const { flip, children, className } = this.props;
        return (
            <button type="button" className={className} onClick={this.handleResetClick} disabled={!flip.flipped.length && !flip.selected.length}>
                {children}
            </button>
        )
    }
}

FlipMatchReset.propTypes = {
    resetGameAction: PropTypes.func.isRequired,
    confirm: PropTypes.string || PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    flip: FLIP_MATCH_STATE_TYPE
};

FlipMatchReset.defaultProps = {
    confirm: false,
    className: '',
    flip: {}
};

const mapDispatchToProps = (dispatch) => ({
    resetGameAction: () =>
        dispatch(resetGame())
});

export default FlipMatchState(connect(
    null,
    mapDispatchToProps
)(FlipMatchReset));